<div class="bloco-card">
  <div class="bloco-topo">
    <div class="bloco-topo-info">
      <span class="bloco-icone bloco-icone--atencao">
        <mat-icon aria-hidden="true">warning</mat-icon>
      </span>
      <div class="bloco-textos">
        <h3 class="bloco-title bloco-title--atencao">Pontos de atenção</h3>
        <p class="bloco-sub">O que precisa da sua ação agora</p>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!loading; else skeleton">
    <div class="atencao-lista">
      <div class="atencao-item">
        <span class="atencao-num">{{ obrasSemInteracao | number }}</span>
        <span class="atencao-texto">obras sem interação há mais de 10 dias</span>
      </div>

      <div class="atencao-item">
        <span class="atencao-num">{{ tarefasAtrasadas | number }}</span>
        <span class="atencao-texto">tarefas atrasadas</span>
      </div>
    </div>
  </ng-container>

  <ng-template #skeleton>
    <div class="atencao-lista">
      <div class="skeleton-atencao" *ngFor="let i of [1,2]"></div>
    </div>
  </ng-template>
</div>